import * as React from "react";
import { ComponentType, ElementType } from "react";
import { ColumnDef, OnChangeFn, PaginationState } from "@tanstack/react-table";
import { QueryObserverResult } from "@tanstack/react-query";
import { EmptyTableConfig } from "./TableCommon";
import { appI18n, getI18nLocale } from "../../modules/i18n/i18n";

export interface QueryTableProps<TData, TError> {
    tableComponent?: ComponentType<any> | ElementType;
    pagination?: PaginationState;
    setPagination?: OnChangeFn<PaginationState>;
    pageCount?: number;
    data: Array<TData>;
    isLoading?: boolean;
    isError?: boolean;
    columns: ColumnDef<TData, any>[];
    title?: string;
    emptyTableConfig?: EmptyTableConfig;
    error?: TError;
    refetch?: () => Promise<QueryObserverResult<any, TError>>;
    hiddenColumns?: string[];
    queryKey?: string;
    totalItems?: number;
    itemTypeLabel?: string;
    // Omit the filter/sort toolbar row for embedded read-only tables (e.g. dashboard previews).
    hideToolbar?: boolean;
}

export const getPageSelectionList = (totalPages: number) => {
    const pageList = [];
    if (totalPages === 0) {
        return [1];
    }
    for (let i = 1; i <= totalPages; i++) {
        pageList.push(i);
    }
    return pageList;
};

export const getItemTypeLabel = (itemTypeLabel: string, totalItems: number, language: string = getI18nLocale()) => {
    const label = itemTypeLabel || appI18n.t("common:table.item", { lng: language });
    if (!language.startsWith("en")) {
        return label;
    }
    const key = label.endsWith("s") ? "common:format.pluralLabelEndingInS" : "common:format.pluralLabel";
    return appI18n.t(key, { count: totalItems, label, lng: language });
};
